import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import { memo } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { closeFullscreen, openFullscreen } from "../../../modules/utils";


const FullScreenButton = ({ isFullScreen }) => {

    // const [isFullScreen, setIsFullScreen] = useState(false);

    const _handleFullScreen = () => {
        if (!isFullScreen) {
            openFullscreen();
            // setIsFullScreen(true);
        } else {
            closeFullscreen();
            // setIsFullScreen(false);
        }
    }

    if (!window.cordova) {
        return <div onClick={_handleFullScreen} className='fullscreen'>{isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}</div>;
    } else {
        return null;
    }


}

const mapStateToProps = ({ user }) => ({
    isFullScreen: user.full_screen,
});

const mapDispatchToProps = dispatch => bindActionCreators(
    {

    },
    dispatch
);

export default memo(connect(mapStateToProps, mapDispatchToProps)(FullScreenButton));